/* Tonic Home V2: shop the look. A dot opens its product card; one card is open at a time.
   "Add" puts the product in the cart through the mini cart, which then opens. */
class ThLooks extends HTMLElement {
  connectedCallback() {
    this.dots = [...this.querySelectorAll('.th-hot')];
    this.dots.forEach((dot) => dot.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = dot.getAttribute('aria-expanded') !== 'true';
      this.closeAll();
      if (open) this.open(dot);
    }));
    this.querySelectorAll('[data-th-add]').forEach((btn) => btn.addEventListener('click', () => {
      const cart = document.querySelector('mini-cart');
      if (!cart || typeof cart.addItem !== 'function') return;
      cart.addItem(Number(btn.dataset.thAdd));
      this.closeAll(false);
    }));
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.th-pop') && !event.target.closest('.th-hot')) this.closeAll(false);
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });
  }

  open(dot) {
    const pop = this.querySelector(`#${dot.getAttribute('aria-controls')}`);
    if (!pop) return;
    pop.hidden = false;
    dot.setAttribute('aria-expanded', 'true');
    this.openDot = dot;
  }

  closeAll(returnFocus = true) {
    const dot = this.openDot;
    this.dots.forEach((d) => {
      d.setAttribute('aria-expanded', 'false');
      const pop = this.querySelector(`#${d.getAttribute('aria-controls')}`);
      if (pop) pop.hidden = true;
    });
    this.openDot = null;
    if (returnFocus && dot && this.contains(document.activeElement)) dot.focus({ preventScroll: true });
  }
}

if (!customElements.get('th-looks')) customElements.define('th-looks', ThLooks);
